(() => {
  const mobile = window.matchMedia("(max-width: 749px)");
  const savedVisibility = new WeakMap();
  let queued = false;

  const update = () => {
    queued = false;
    const launcher = document.querySelector("#beacon-container .BeaconFabButtonFrame");
    if (!launcher) return;
    if (!savedVisibility.has(launcher)) {
      savedVisibility.set(launcher, {
        value: launcher.style.getPropertyValue("visibility"),
        priority: launcher.style.getPropertyPriority("visibility"),
      });
    }
    const rect = launcher.getBoundingClientRect();
    const focused = launcher.contains(document.activeElement);
    const overlaps = mobile.matches && !focused && rect.width > 0 && Array.from(
      document.querySelectorAll('.snize-action-button, button[name="add"], [name="checkout"]'),
    ).some(button => {
      const box = button.getBoundingClientRect();
      return box.width > 0 && box.height > 0 &&
        box.left < rect.right + 6 && box.right > rect.left - 6 &&
        box.top < rect.bottom + 6 && box.bottom > rect.top - 6;
    });
    if (overlaps) {
      launcher.style.setProperty("visibility", "hidden", "important");
    } else {
      const saved = savedVisibility.get(launcher);
      if (saved.value) launcher.style.setProperty("visibility", saved.value, saved.priority);
      else launcher.style.removeProperty("visibility");
    }
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  document.addEventListener("focusin", schedule);
  document.addEventListener("focusout", schedule);
  mobile.addEventListener("change", schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
